export const URL='https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=AIzaSyC6pTHpZyCjk7EE-H72Xluo5E6hIw1BkHM'
